/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { Dropdown } from 'react-bootstrap';
import DateFnsUtils from '@date-io/date-fns';
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from '@material-ui/pickers';
import MenuItem from '@material-ui/core/MenuItem';
import _ from 'lodash';
import { Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import AppBar from '@material-ui/core/AppBar';
import moment from 'moment';
import Spinner from '../../../SharedModules/Spinner/SpinnerNew';
import CustomSeparator from '../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import SVGComponent from '../../../SharedModules/SVGComponents/SVGComponents';
import ErrorMessages from '../../../SharedModules/Errors/ErrorMessages';
import * as AppConstants from '../../../SharedModules/AppConstants';
import DisplaySuccessMessages from '../../../SharedModules/Errors/SuccessMessage';
import CommentIcon from '../../../assets/images/comment-dots.svg';
import CommentAndCorrespondenceComponent from '../../../SharedModules/MicroFrontend/CommentAndCorrespondenceComponent';
import CommentVisibleIcon from '../../../assets/images/commen-visible-icon.svg';
import SaveCancelPopup from '../../../SharedModules/CustomSaveCancelPopup/SaveCancelPopup';
import {
  URASoruceHead,
  URACalcHead,
  URAPaymentHead,
  InterestCalcHead,
  FederalFamilyHead,
  FederalPercentHead,
} from './tablehead';
import {
  removeErr,
  tabHighLigther,
  makeFormDirty,
} from '../../../SharedModules/utilities/utilities';
import { closeTab } from '../../../SharedModules/CommonUtilities/commonUtilities';
import CommonModal from '../../../SharedModules/Dialog/CommonModal';
import TableGrid from '../../../SharedModules/Table/TableGridWithFeatures';
import {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../SharedModules/AgGridUtilities/suppressNavigation';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { redirectURLLink } from '../../../SharedModules/CommonUtilities/commonUtilities';
import ViewHistoryComponent from '../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { getCheckPay, getDropdownByCode } from './store/actions';
import * as Messages from './RebatePgmConstants';
import * as constantMessageData from '../../../SharedModules/Errors/constantMessageData';

const InvoiceDetailsTab = (props) => {
  const dispatch = useDispatch();
  const { changeHandler, blurHandler, flderr, details, isEnablebyRole } = props;
  const [cover_letter, setCoverletter] = React.useState([]);
  const [cms_drug, setCmsDrug] = React.useState([]);
  // const cover_letter = useSelector(
  //   (state) => state?.sharedState?.RebatePgmReducer?.cover_letter
  // );
  // const cms_drug = useSelector(
  //   (state) => state?.sharedState?.RebatePgmReducer?.cms_drug
  // );

  const getDropdownData = async () => {
    let list = await dispatch(
      getDropdownByCode(['COVER_LETTER_PLACEMENT_CD', 'NON_CMS_DRUG_INCL_CD'])
    );
    setCoverletter(
      list?.COVER_LETTER_PLACEMENT_CD ? list.COVER_LETTER_PLACEMENT_CD : []
    );
    setCmsDrug(list?.NON_CMS_DRUG_INCL_CD ? list.NON_CMS_DRUG_INCL_CD : []);
  };

  React.useEffect(() => {
    // if (!cover_letter) dispatch(getCheckPay('COVER_LETTER_PLACEMENT_CD'));
    // if (!cms_drug) dispatch(getCheckPay('NON_CMS_DRUG_INCL_CD'));
    getDropdownData();
  }, []);

  const renderTooltipL1 = (propsTooltip) => {
    return details?.invoiceHdrLine1 && details?.invoiceHdrLine1.length > 20 ? (
      <Tooltip id='add-tooltip' {...propsTooltip}>
        {details?.invoiceHdrLine1}
      </Tooltip>
    ) : (
      <p {...propsTooltip} />
    );
  };

  const renderTooltipL2 = (propsTooltip) => {
    return details?.invoiceHdrLine2 && details?.invoiceHdrLine2.length > 20 ? (
      <Tooltip id='add-tooltip' {...propsTooltip}>
        {details?.invoiceHdrLine2}
      </Tooltip>
    ) : (
      <p {...propsTooltip} />
    );
  };

  const renderTooltipL3 = (propsTooltip) => {
    return details?.invoiceHdrLine3 && details?.invoiceHdrLine3.length > 20 ? (
      <Tooltip id='add-tooltip' {...propsTooltip}>
        {details?.invoiceHdrLine3}
      </Tooltip>
    ) : (
      <p {...propsTooltip} />
    );
  };

  const renderTooltipL4 = (propsTooltip) => {
    return details?.invoiceHdrLine4 && details?.invoiceHdrLine4.length > 20 ? (
      <Tooltip id='add-tooltip' {...propsTooltip}>
        {details?.invoiceHdrLine4}
      </Tooltip>
    ) : (
      <p {...propsTooltip} />
    );
  };

  return (
    <div data-testid='InvoiceDetailsTab'>
      <div className='row my-1'>
        <div className='col-sm-12 col-lg-6'>
          <fieldset className='custom-fieldset' style={{ height: 'auto' }}>
            <legend className='same-font-family'>
              Invoice Header <span className='mandatory'>*</span>
            </legend>
            <div className='form-wrapper'>
              <div className='mui-custom-form'>
                <OverlayTrigger placement='top' overlay={renderTooltipL1}>
                  <TextField
                    className='mb-1'
                    id='line1'
                    label='Line 1'
                    data-testid='line1'
                    inputProps={{ id: 'line1', maxLength: 120 }}
                    InputLabelProps={{ shrink: true }}
                    value={details?.invoiceHdrLine1 || ''}
                    onChange={(e) =>
                      changeHandler(e.target.value, 'invoiceHdrLine1')
                    }
                    onBlur={(e) =>
                      blurHandler(e.target.value, 'invoiceHdrLine', details)
                    }
                    disabled={!isEnablebyRole}
                  />
                </OverlayTrigger>
                <OverlayTrigger placement='top' overlay={renderTooltipL3}>
                  <TextField
                    className='mb-1'
                    id='line3'
                    data-testid='line3'
                    label='Line 3'
                    inputProps={{ id: 'line3', maxLength: 120 }}
                    InputLabelProps={{ shrink: true }}
                    value={details?.invoiceHdrLine3 || ''}
                    onChange={(e) =>
                      changeHandler(e.target.value, 'invoiceHdrLine3')
                    }
                    onBlur={(e) =>
                      blurHandler(e.target.value, 'invoiceHdrLine', details)
                    }
                    disabled={!isEnablebyRole}
                  />
                </OverlayTrigger>
              </div>
              <div className='mui-custom-form'>
                <OverlayTrigger placement='top' overlay={renderTooltipL2}>
                  <TextField
                    className='mb-1'
                    id='line2'
                    data-testid='line2'
                    label='Line 2'
                    inputProps={{ id: 'line2', maxLength: 120 }}
                    InputLabelProps={{ shrink: true }}
                    value={details?.invoiceHdrLine2 || ''}
                    onChange={(e) =>
                      changeHandler(e.target.value, 'invoiceHdrLine2')
                    }
                    onBlur={(e) =>
                      blurHandler(e.target.value, 'invoiceHdrLine', details)
                    }
                    disabled={!isEnablebyRole}
                  />
                </OverlayTrigger>
                <OverlayTrigger placement='top' overlay={renderTooltipL4}>
                  <TextField
                    className='mb-1'
                    id='line4'
                    data-testid='line4'
                    label='Line 4'
                    inputProps={{ id: 'line4', maxLength: 120 }}
                    InputLabelProps={{ shrink: true }}
                    value={details?.invoiceHdrLine4 || ''}
                    onChange={(e) =>
                      changeHandler(e.target.value, 'invoiceHdrLine4')
                    }
                    onBlur={(e) =>
                      blurHandler(e.target.value, 'invoiceHdrLine', details)
                    }
                    disabled={!isEnablebyRole}
                  />
                </OverlayTrigger>
              </div>
            </div>
          </fieldset>
        </div>
        <div className='col-sm-12 col-lg-6'>
          <fieldset className='custom-fieldset' style={{ height: 'auto' }}>
            <legend className='same-font-family'>Other Payments</legend>
            <div className='mui-custom-form frr-custom-font-12m600 d-flex flex-column'>
              <FormControlLabel
                className='mt-2 ml-1 pt-1'
                control={<Checkbox color='primary' />}
                label='Include TPL Amount'
                value={details?.inclTplAmtInd === 1 ? true : false}
                onChange={(e, val) => changeHandler(val, 'inclTplAmtInd', true)}
                checked={details?.inclTplAmtInd === 1 ? true : false}
                data-testid='tplamt'
                disabled={!isEnablebyRole}
              />
              <FormControlLabel
                className='mt-2 ml-1 frr-custom-font-12m600 pt-1'
                control={<Checkbox color='primary' />}
                label='Include Co-pay Amount'
                value={details?.inclCopayAmtInd === 1 ? true : false}
                onChange={(e, val) =>
                  changeHandler(val, 'inclCopayAmtInd', true)
                }
                checked={details?.inclCopayAmtInd === 1 ? true : false}
                data-testid='copayamt'
                disabled={!isEnablebyRole}
              />
              <FormControlLabel
                className='mt-2 ml-1 frr-custom-font-12m600 pt-1 pb-1'
                control={<Checkbox color='primary' />}
                label='Include Deductible Amount'
                value={details?.inclDeductibleAmtInd === 1 ? true : false}
                onChange={(e, val) =>
                  changeHandler(val, 'inclDeductibleAmtInd', true)
                }
                checked={details?.inclDeductibleAmtInd === 1 ? true : false}
                data-testid='dedamt'
                disabled={!isEnablebyRole}
              />
            </div>
          </fieldset>
        </div>
      </div>
      <fieldset className='custom-fieldset mt-3' style={{ height: 'auto' }}>
        <legend aria-hidden='true' className='d-none' />
        <div className='row'>
          <div className='mui-custom-form mt-1 frr-mui-custom-form-new d-flex flex-column pt-4 col-sm-12 col-md-6 col-lg-4'>
            <FormControlLabel
              className='mt-2 ml-0 mb-0 pb-1 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Cover Letter'
              value={details?.section4Ind === 1 ? true : false}
              onChange={(e, val) => changeHandler(val, 'section4Ind', true)}
              checked={details?.section4Ind === 1 ? true : false}
              data-testid='letterplmt'
              disabled={!isEnablebyRole}
            />
            {details?.section4Ind === 1 && (
              <div className='input-md mandate-fields'>
                <TextField
                  id='emptyhead'
                  className='mb-3'
                  data-testid='emptyhead'
                  label='Cover Letter Placement'
                  InputProps={{ id: 'emptyhead' }}
                  InputLabelProps={{ shrink: true }}
                  select
                  value={details?.coverLetterPlacementCd || ''}
                  onChange={(e) =>
                    changeHandler(e.target.value, 'coverLetterPlacementCd')
                  }
                  disabled={!isEnablebyRole}
                >
                  <MenuItem
                    className='frr-dropdown-blank-item'
                    key=''
                    value='-1'
                  >
                    {''}
                  </MenuItem>
                  {cover_letter &&
                    cover_letter.map((item, ind) => (
                      <MenuItem key={ind} value={item.codeValueID.codeValue}>
                        {item.shortDescription}
                      </MenuItem>
                    ))}
                </TextField>
              </div>
            )}
            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Flag Unit Conversion'
              value={details?.flagUnitConversionInd === 1 ? true : false}
              onChange={(e, val) =>
                changeHandler(val, 'flagUnitConversionInd', true)
              }
              checked={details?.flagUnitConversionInd === 1 ? true : false}
              data-testid='flagunit'
              disabled={!isEnablebyRole}
            />
            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Display Zero URA on Section 3'
              value={details?.dispZeroUraInd === 1 ? true : false}
              onChange={(e, val) => changeHandler(val, 'dispZeroUraInd', true)}
              checked={details?.dispZeroUraInd === 1 ? true : false}
              data-testid='dspsec3'
              disabled={!isEnablebyRole}
            />
            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Display Drugs with No URA on Section 3'
              value={details?.dispNoUraInd === 1 ? true : false}
              onChange={(e, val) => changeHandler(val, 'dispNoUraInd', true)}
              checked={details?.dispNoUraInd === 1 ? true : false}
              data-testid='dspdrug'
              disabled={!isEnablebyRole}
            />
            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label="Default Display 'Duplicate' on Invoice"
              value={details?.dispDupOnInvInd === 1 ? true : false}
              onChange={(e, val) => changeHandler(val, 'dispDupOnInvInd', true)}
              checked={details?.dispDupOnInvInd === 1 ? true : false}
              data-testid='defaultdsp'
              disabled={!isEnablebyRole}
            />
            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Include Claims where Submitted Amount Equals Zero'
              value={details?.inclZeroSubmitAmtClmInd === 1 ? true : false}
              onChange={(e, val) =>
                changeHandler(val, 'inclZeroSubmitAmtClmInd', true)
              }
              checked={details?.inclZeroSubmitAmtClmInd === 1 ? true : false}
              data-testid='defaultdsp'
              disabled={!isEnablebyRole}
            />
          </div>
          <div className='mui-custom-form frr-mui-custom-form-new col-sm-12 col-md-4 col-lg-3'>
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3 '
                id='oldinvoice'
                data-testid='oldinvoice'
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 2, id: 'oldinvoice' }}
                value={details?.oldInvoicePrefix || null}
                onChange={(e) =>
                  changeHandler(
                    parseInt(e.target.value, 10),
                    'oldInvoicePrefix'
                  )
                }
                label='Old Invoice Prefix'
                onBlur={(e) => blurHandler(e.target.value, 'oldInvoicePrefix')}
                helperText={
                  flderr?.oldInvoicePrefixErr
                    ? Messages.OLD_INVOICE_PREFIX_NUM_ERR
                    : null
                }
                error={flderr?.oldInvoicePrefixErr}
                disabled={!isEnablebyRole}
              />
            </div>
            <div className='input-md mandate-fields frr-text-feild-wrap'>
              <TextField
                className='mb-3 frr-label-width-350'
                id='cmscode'
                data-testid='cmscode'
                label='Inclusion Code for Drugs Not on CMS'
                required
                select
                InputProps={{ id: 'cmscode' }}
                InputLabelProps={{ shrink: true }}
                value={details?.nonCmsDrugInclCd || ''}
                onChange={(e) =>
                  changeHandler(e.target.value, 'nonCmsDrugInclCd')
                }
                onBlur={(e) => blurHandler(e.target.value, 'nonCmsDrugInclCd')}
                helperText={
                  flderr?.nonCmsDrugInclCdErr
                    ? Messages.INCLUSION_CODE_ERR
                    : null
                }
                error={flderr?.nonCmsDrugInclCdErr}
                disabled={!isEnablebyRole}
              >
                <MenuItem className='frr-dropdown-blank-item' key='' value='-1'>
                  {''}
                </MenuItem>
                {cms_drug &&
                  cms_drug.map((item, ind) => (
                    <MenuItem key={ind} value={item.codeValueID.codeValue}>
                      {item.codeValueID.codeValue}: {item.shortDescription}
                    </MenuItem>
                  ))}
              </TextField>
            </div>
            <div className='input-md mandate-fields'>
              <TextField
                className='mb-3'
                id='qtrhash'
                data-testid='qtrhash'
                label='# of Quarters'
                inputProps={{ maxLength: 2, id: 'qtrhash' }}
                InputLabelProps={{ shrink: true }}
                value={details?.nonCmsDrugInclQtrs || ''}
                onChange={(e) =>
                  changeHandler(
                    parseInt(e.target.value, 10),
                    'nonCmsDrugInclQtrs'
                  )
                }
                disabled={
                  !(
                    details?.nonCmsDrugInclCd === 'NEWZERO' ||
                    details?.nonCmsDrugInclCd === 'NEWCALC'
                  ) || !isEnablebyRole
                }
                onBlur={(e) =>
                  blurHandler(
                    e.target.value,
                    'nonCmsDrugInclQtrs',
                    details?.nonCmsDrugInclCd === 'NEWZERO' ||
                      details?.nonCmsDrugInclCd === 'NEWCALC'
                  )
                }
                helperText={
                  flderr?.nonCmsDrugInclQtrsReqErr
                    ? Messages.INCLUSION_QTR_ER
                    : flderr?.nonCmsDrugInclQtrsVldErr
                    ? Messages.INCLUSION_QTR_VLD_ER
                    : null
                }
                error={
                  flderr?.nonCmsDrugInclQtrsReqErr ||
                  flderr?.nonCmsDrugInclQtrsVldErr
                }
              />
            </div>
          </div>
          <div className='mui-custom-form frr-custom-font-12m600 d-flex flex-column frr-mui-custom-form-new col-sm-12  col-lg-3'>
            <FormControlLabel
              className='mt-2 ml-0'
              control={<Checkbox color='primary' />}
              label='Invoice 340b Claims'
              value={details?.process340bInd === 1 ? true : false}
              onChange={(e, val) => changeHandler(val, 'process340bInd', true)}
              checked={details?.process340bInd === 1 ? true : false}
              data-testid='process340bInd'
              disabled={
                details?.planTypeCd === 'FD' ? true : false || !isEnablebyRole
              }
            />
            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Use Federal Invoice format'
              value={
                details?.planTypeCd === 'FD' || details?.planTypeCd === 'ST'
                  ? true
                  : details?.useFdInvFormatInd === 1
                  ? true
                  : false
              }
              onChange={(e, val) =>
                changeHandler(val, 'useFdInvFormatInd', true)
              }
              checked={
                details?.planTypeCd === 'FD' || details?.planTypeCd === 'ST'
                  ? true
                  : details?.useFdInvFormatInd === 1
                  ? true
                  : false
              }
              data-testid='useFdInvFormatInd'
              disabled={
                details?.planTypeCd === 'FD' || details?.planTypeCd === 'ST'
                  ? true
                  : false || !isEnablebyRole
              }
            />
            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label='Include Vaccines'
              value={details?.inclVaccineInd === 1 ? true : false}
              onChange={(e, val) => changeHandler(val, 'inclVaccineInd', true)}
              checked={details?.inclVaccineInd === 1 ? true : false}
              data-testid='inclVaccineInd'
              disabled={details?.planTypeCd === 'FD' || !isEnablebyRole}
            />
            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600'
              control={<Checkbox color='primary' />}
              label="Don't Test CMS DESI Code"
              value={details?.omitCmsDesiCheckInd === 1 ? true : false}
              onChange={(e, val) =>
                changeHandler(val, 'omitCmsDesiCheckInd', true)
              }
              checked={details?.omitCmsDesiCheckInd === 1 ? true : false}
              data-testid='omitCmsDesiCheckInd'
              disabled={details?.planTypeCd === 'FD' || !isEnablebyRole}
            />
            <FormControlLabel
              className='mt-2 ml-0 frr-custom-font-12m600 '
              control={<Checkbox color='primary' />}
              label='Include Claims with Zero Reimbursement'
              value={details?.inclZeroReimbClmInd === 1 ? true : false}
              onChange={(e, val) =>
                changeHandler(val, 'inclZeroReimbClmInd', true)
              }
              checked={details?.inclZeroReimbClmInd === 1 ? true : false}
              data-testid='inclZeroReimbClmInd'
              disabled={details?.planTypeCd === 'FD' || !isEnablebyRole}
            />
          </div>
        </div>
      </fieldset>
    </div>
  );
};

export default InvoiceDetailsTab;
